export const PARTICIPANT_ACTIVITY_COLUMNS = [
  "Modality Id",
  "Neurostamp Id",
  "Coordinator Name",
  "Relation To ALS",
  "Last Contacted",
  "Last Contacted By",
  "First Session Date",
  "Last Session Date",
  "Date Joined",
  "No Of Sessions",
  "Status",
];

export const VIEW_REPORT_COLUMNS = ["Modality Id", "Date Of Joining"];

export const PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS = [
  "Neurostamp Id",
  "Relation To ALS",
  "First Session Date",
  "Last Session Date",
  "Date Joined",
  "No Of Sessions",
  "Gender",
  "Date of Diagnosis",
  "Date of Onset",
  "Age",
  // "Latest ALSFRS-R Score",
  // "Ethincity",
  "Status",
];

export const VIEW_REPORT_COLUMNS_WITHOUT_DETAILS = [
  "Modality Id",
  "Date Of Joining",
];

export const PARTICIPANT_ACTIVITY_COLUMNS_FOR_SESSIONS = [
  "Modality Id",
  "Neurostamp Id",
  "Coordinator Name",
  "Relation To ALS",
  "Last Contacted",
  "Last Contacted By",
  "First Session Date",
  "Date Joined",
  "No Of Sessions",
  "Last Session Date",
  "Status",
];

export const PARTICIPANT_ACTIVITY_COLUMNS_WITHOUT_DETAILS_FOR_SESSIONS = [
  // "Modality Id",
  "Neurostamp Id",
  // "Coordinator Name",
  "Relation To ALS",
  // "Last Contacted",
  // "Last Contacted By",
  "First Session Date",
  "Date Joined",
  "No Of Sessions",
  "Last Session Date",
  "Status",
];

export const ACTIVE_PARTICIPANT_COLUMNS = [
  "Status",
  "EALS ID",
  "Neurostamp Id",
  "DOB",
  "Date of Diagnosis",
  "Date Joined",
  "No Of Sessions",
  "Shoe Size",
  "Gait Assistive Devices",
  "Breathing Assistive Devices",
  "Relation To ALS",
];
export const ACTIVE_PARTICIPANT_COLUMNS_WITHOUT_DETAILS = [
  "Status",
  "Neurostamp Id",
  "Date of Diagnosis",
  "Date Joined",
  "No Of Sessions",
  "Shoe Size",
  "Relation To ALS",
];
export const ACTIVE_PARTICIPANT_COLUMNS_RADCLIFF = [
  "Status",
  "Neurostamp Id",
  "DOB",
  "Date of Diagnosis",
  "Date Joined",
  "No of sessions",
  "First Session Date",
  "Last Session Date",
  "Shoe Size",
  "Relation To ALS",
  "Session Frequecy",
  "Independant/Coach",
];
// "No Of Sessions",
export const ACTIVE_PARTICIPANT_COLUMNS_WITHOUT_DETAILS_RADCLIFF = [
  "Neurostamp Id",
  "Date Joined",
  "No of sessions",
  "First Session Date",
  "Last Session Date",
  "Shoe Size",
  "Relation To ALS",
  "Independant/Coach",
  "Gender",
  "Date of Diagnosis",
  "Date of Onset",
  "Age",
  "Ethincity",
  "Status",
];

export const NOT_ACTIVE_PARTICIPANT_COLUMNS_RADCLIFF = [
  "Status",
  "EALS ID",
  "Neurostamp Id",
  "DOB",
  "Date of Diagnosis",
  "Date Joined",
  "No of sessions",
  "First Session Date",
  "Last Session Date",
  "Shoe Size",
  "Gait Assistive Devices",
  "Breathing Assistive Devices",
  "Relation To ALS",
  "Session Frequecy",
];
// "No Of Sessions",
export const NOT_ACTIVE_PARTICIPANT_COLUMNS_WITHOUT_DETAILS_RADCLIFF = [
  "Status",
  "EALS ID",
  "Neurostamp Id",
  "Date of Diagnosis",
  "Date Joined",
  "No of sessions",
  "First Session Date",
  "Last Session Date",
  "Shoe Size",
  "Relation To ALS",
];
export const ACTIVE_STATUS_LIST = ["Study Completed", "Account Created", "New"];
export const NOT_ACTIVE_STATUS_LIST = ["Dropped Out", "Cancel"];
export const ALL_STATUS_LIST = [
  "New",
  "Study Completed",
  "Account Created",
  "Cancel",
  "Dropped Out",
];
export const RADCLIFF_ONBOARDING_STATUS = [
  "Enrolled in Radcliff",
  "Preparing Shipment",
  "Ready to Ship",
  "Shipped",
  "Received",
  "Data Collection",
  "Onboarded",
  "On Hold",
  "Not Responding",
];

export const FILTER_BY_ACTIVITY_LIST = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Withdrawn",
    value: "not_active",
  },
];
export const FILTER_BY_ALS_AND_CONTROLS_LIST = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "ALS",
    value: "als",
  },
  {
    label: "Controls",
    value: "controls",
  },
];
export const RADCLIFF_ONBOARDING_STATUS_LIST = [
  {
    label: "Enrolled in Radcliff",
    value: "Enrolled in Radcliff",
  },
  {
    label: "Preparing Shipment",
    value: "Preparing Shipment",
  },
  {
    label: "Ready to Ship",
    value: "Ready to Ship",
  },
  {
    label: "Shipped",
    value: "Shipped",
  },
  {
    label: "Received",
    value: "Received",
  },
  {
    label: "Data Collection",
    value: "Data Collection",
  },
];
export const ENROLLMENT_STATUS_LIST = [
  "Interest Form Completed",
  "Initial email sent",
  "1st Contact Attempt",
  "2nd Contact Attempt",
  "3rd Contact Attempt",
  "LTFU",
  "Not ideal candidate",
  "Potential Participant Declined",
  "Not at this time",
];
export const CONNECTION_TO_ALS_LIST = [
  "Living with ALS",
  "Asymptomatic Gene Carrier",
  "Caregiver",
  "Family Member",
  "Friend",
  "Healthcare professional",
  "Other",
];
